import React, { useEffect, useState } from "react";
import { db } from "../../firebase";
import { collection, query, where, onSnapshot } from "firebase/firestore";
import Header from "../../components/Header/Header";

// Standardized Time Slot Generator
// const generateTimeSlots = () => {
//   const slots: string[] = [];
//   for (let hour = 0; hour < 24; hour++) {
//     for (let min of [0, 30]) {
//       const h = hour.toString().padStart(2, "0");
//       const m = min.toString().padStart(2, "0");
//       slots.push(`${h}:${m}`);
//     }
//   }
//   return slots;
// };

const generateTimeSlots = () => {
    const slots: string[] = [];
    // Start at 9 (9 AM) and go up to 22 (10 PM)
    for (let hour = 9; hour <= 22; hour++) {
        for (let min of ["00", "30"]) {
            // Stop at 22:00 (10:00 PM) and don't include 22:30
            if (hour === 22 && min === "30") break;

            const h = hour.toString().padStart(2, "0");
            const m = min.toString().padStart(2, "0");
            slots.push(`${h}:${m}`);
        }
    }
    return slots;
};

const formatToAMPM = (time24: string) => {
  const [hourStr, minute] = time24.split(":");
  let hour = parseInt(hourStr, 10);
  const period = hour >= 12 ? "PM" : "AM";
  hour = hour % 12 || 12;
  return `${hour}:${minute} ${period}`;
};

const allTimeSlots = generateTimeSlots();

const History: React.FC = () => {
  const [lotteries, setLotteries] = useState<{ id: string, name: string }[]>([]);
  const [selectedLottery, setSelectedLottery] = useState("");
  const [monthYear, setMonthYear] = useState(`${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, "0")}`);
  const [historyData, setHistoryData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const q = query(collection(db, "lotteryNames"), where("isActive", "==", true));
    
    const unsub = onSnapshot(q, (snap) => {
      const list = snap.docs.map(d => ({ id: d.id, name: d.data().name }));
      setLotteries(list);

      if (list.length > 0) {
        // We use a functional update to access the current selectedLottery 
        // without needing it in the dependency array.
        setSelectedLottery((currentSelected) => {
          const isStillActive = list.some(l => l.id === currentSelected);
          if (!currentSelected || !isStillActive) {
            return list[0].id;
          }
          return currentSelected;
        });
      } else {
        // This will now trigger immediately when the last lottery is disabled
        setSelectedLottery("");
        setHistoryData([]);
        setLoading(false);
      }
    });
    
    return () => unsub();
  }, []);

  useEffect(() => {
    if (!selectedLottery) return;
    setLoading(true);
    const [year, month] = monthYear.split("-");
    const resultsRef = collection(db, "lotteryResults", selectedLottery, "dates");

    const unsubscribe = onSnapshot(resultsRef, (snap) => {
      const filtered = snap.docs
        .map(d => d.data())
        .filter(data => {
          const d = new Date(data.date);
          return (d.getMonth() + 1) === parseInt(month) && d.getFullYear() === parseInt(year);
        })
        .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());

      setHistoryData(filtered);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [selectedLottery, monthYear]);

  return (
    <div className="h-[100dvh] bg-gray-100 flex flex-col justify-center items-center p-2">

      {/* Big Main Card */}
      <div className="w-full max-w-3xl bg-[#fffcf9] border border-black rounded-2xl shadow-lg p-3 flex flex-col h-[100dvh] max-h-[95vh]">
        {/* <div className="flex justify-between items-center mb-2 shrink-0">
          <img src={logo} alt="Logo" className="h-10 w-auto object-contain" />
          <button
            onClick={() => navigate(-1)}
            className="bg-black text-white text-[10px] font-bold px-3 py-1.5 rounded-full hover:bg-[#fa3815] transition"
          >
            Back
          </button>
        </div> */}

        <Header
            isShowLogout={false} 
            buttonTitle="Home"
            targetPath="/home"
        />

        {lotteries.length>0 &&
          <div className="gap-2 mb-2">
              {lotteries.length === 1 ? (
                 <div className=" flex flex-col text-center mb-2 mt-2 shrink-0">
                  <span className="text-[#fa3815] text-2xl font-bold text-center">{lotteries[0].name}</span>
                </div>
              ):(
              <select
                value={selectedLottery}
                onChange={(e) => setSelectedLottery(e.target.value)}
                className="border border-black p-2 rounded-full bg-white text-xs font-bold outline-none mb-2 w-full"
              >
                {lotteries.map(l => <option key={l.id} value={l.id}>{l.name}</option>)}
              </select>
              // <div className="relative mb-2 w-full group">
              //   <select
              //     value={selectedLottery}
              //     onChange={(e) => setSelectedLottery(e.target.value)}
              //     className="w-full border border-black p-2.5 pr-10 rounded-full bg-white text-xs font-bold outline-none appearance-none cursor-pointer hover:border-[#fa3815] transition-all"
              //   >
              //     {lotteries.map(l => <option key={l.id} value={l.id}>{l.name}</option>)}
              //   </select>
                
              //   {/* Custom High-Visibility Arrow Icon */}
              //   <div className="absolute inset-y-0 right-4 flex items-center pointer-events-none">
              //     <svg 
              //       className="w-4 h-4 text-black group-hover:text-[#fa3815] transition-colors" 
              //       fill="none" 
              //       stroke="currentColor" 
              //       viewBox="0 0 24 24"
              //     >
              //       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M19 9l-7 7-7-7" />
              //     </svg>
              //   </div>
              // </div>
            )}
            {/* <input
              type="month"
              value={monthYear}
              onChange={(e) => setMonthYear(e.target.value)}
              className="border border-black p-2 rounded-full bg-white text-xs font-bold outline-none w-full"
            /> */}
            <div className="relative w-full">
            <input
              type="month"
              value={monthYear}
              onChange={(e) => setMonthYear(e.target.value)}
              className="w-full border border-black p-2.5 pr-10 rounded-full bg-white text-xs font-bold outline-none appearance-none cursor-pointer"
            />
            <div className="absolute inset-y-0 right-4 flex items-center pointer-events-none">
              <svg className="w-4 h-4 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
            </div>
          </div>
          </div>
        }

        {/* Scrollable Area */}
        <div className="flex-1 flex flex-col overflow-auto relative">
          {lotteries.length === 0 ? (
            <div className="flex-1 flex flex-col items-center justify-center p-6 text-center">
              <div className="w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center mb-4">
                <span className="text-2xl">🚫</span>
              </div>
              <h2 className="text-lg font-bold text-gray-800">No Active Lotteries</h2>
              <p className="text-gray-500 text-xs mt-1">Please check back later for new updates.</p>
            </div>
          ) : (
            <table className="w-full text-center border-collapse text-[10px] md:text-xs">
              {historyData.length > 0 &&
                <thead className="sticky top-0 z-30 shadow-sm">
                  <tr className="text-white">
                    {/* Sticky Top-Left Corner */}
                    {/* <th className="p-2 border border-black bg-red-800 sticky left-0 z-40 min-w-[85px]">
                      Date
                    </th> */}
                    {/* <th className="p-2 border border-black bg-red-800 sticky left-0 z-40 min-w-[100px] text-[10px] tracking-tighter">
                      <div className="flex flex-col items-center justify-center leading-tight">
                        <span>Date</span>
                        <div className="w-full h-[1px] bg-white/30 my-0.5"></div>
                        <span>Time</span>
                      </div>
                    </th> */}
                    <th 
                      className="sticky p-0 border border-black bg-[#fa3815] left-0 z-40 min-w-[80px] h-9 overflow-hidden"
                      style={{
                        background: 'linear-gradient(to border-top-right, transparent calc(50% - 0.5px), #ffffff50, transparent calc(50% + 0.5px)), #991b1b'
                      }}
                    >
                      {/* Label for Time (Top Right) */}
                      <span className="absolute top-1 right-2 text-[9px] font-bold uppercase tracking-wider text-white">
                        Time
                      </span>
                      
                      {/* Diagonal Line using SVG for precision */}
                      <svg className="absolute inset-0 w-full h-full" preserveAspectRatio="none">
                        <line x1="0" y1="0" x2="100%" y2="100%" stroke="rgba(255,255,255)" strokeWidth="1" />
                      </svg>

                      {/* Label for Date (Bottom Left) */}
                      <span className="absolute bottom-1 left-2 text-[9px] font-bold uppercase tracking-wider text-white">
                        Date
                      </span>
                    </th>
                    {allTimeSlots.map(slot => (
                      <th key={slot} className="p-2 border border-black min-w-[55px] whitespace-nowrap bg-[#fb735b]">
                        {formatToAMPM(slot)}
                      </th>
                    ))}
                  </tr>
                </thead>
              }
              <tbody className="relative z-10">
                {loading ? (
                  <tr><td colSpan={allTimeSlots.length + 1} className="p-10 font-bold text-gray-400">Loading...</td></tr>
                ) : historyData.length === 0 ? (
                  <tr><td colSpan={allTimeSlots.length + 1} className="p-10 text-gray-400">No records found.</td></tr>
                ) : (
                  historyData.map((day, idx) => {
                    const rowColor = idx % 2 === 0 ? "bg-white" : "bg-[#fdf2f2]"; // Fixed solid light red
                    const dateColBg = "bg-[#fb735b]";
                    return(
                      <tr key={idx} className={rowColor}>
                        {/* Sticky Left Column */}
                        <td className={`p-2 border border-black font-black sticky left-0 z-20 whitespace-nowrap shadow-[1px_0_0_0_#000] ${dateColBg} text-white`}>
                          {day.date.split('-').reverse().join('-')}
                        </td>
                        {allTimeSlots.map(slot => {
                          const resultNumber = day.slots[slot]?.number;
                          return(
                            <td key={slot} className="p-2 border border-black font-medium text-black">
                              {resultNumber !== null && resultNumber !== undefined 
                              ? String(resultNumber).padStart(2, "0") 
                              : "-"}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
      {/* Mobile Footer Tip */}
      <div className="md:hidden p-1 bg-gray-100 text-center text-[8px] text-black font-bold uppercase tracking-widest border-t">
        Swipe left/right to view all times
      </div>
    </div>
  );
};

export default History;